module.exports = __webpack_public_path__ + "static/media/Download.1837a262.svg";